import { motion } from 'motion/react';
import { Link } from 'react-router-dom';
import { Container, Kicker, Mark } from './primitives';
import { PresenzeMini } from './FeatureVisuals';
import { Badge } from './ui/badge';
import { Button } from './ui/button';

const STEPS = ['Rapportino dal cantiere', 'Calcoli e 12 controlli', 'File per il consulente'];

export function PayrollSpotlight({ index = '01' }: { index?: string }) {
  return (
    <section id="paghe" className="relative border-t border-border py-28 md:py-36">
      <Container>
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-[1fr_1.15fr] lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex flex-wrap items-center gap-3">
              <Kicker index={index} label="Presenze e buste paga" />
              <Badge variant="soft">CCNL edilizia · metalmeccanico</Badge>
            </div>
            <h2 className="boss-display mt-5 text-balance text-[40px] md:text-[60px]">
              Buste paga a fine mese? <Mark>Un clic.</Mark>
            </h2>
            <p className="mt-5 max-w-xl text-pretty text-[16px] leading-[1.55] text-fg-2">
              Le ore nascono in cantiere, gli straordinari si calcolano da soli e il file per il tuo consulente
              del lavoro è pronto in un clic, nel formato Inaz o TeamSystem.
            </p>
            <ol className="mt-7 flex flex-wrap items-center gap-2">
              {STEPS.map((s, i) => (
                <li key={s} className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-[12px] text-fg-2">
                    <span className="font-mono text-[10px] text-primary">0{i + 1}</span>
                    {s}
                  </span>
                  {i < STEPS.length - 1 && <span aria-hidden className="text-muted-foreground">→</span>}
                </li>
              ))}
            </ol>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild size="lg">
                <Link to="/funzionalita/presenze-buste-paga">
                  Come funziona <span aria-hidden>→</span>
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline">
                <a href="#demo">Prenota una demo</a>
              </Button>
            </div>
          </motion.div>

          <PresenzeMini />
        </div>
      </Container>
    </section>
  );
}
